import React, { Component } from 'react';
import PropTypes from 'prop-types';

class FoodImage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.fallback = this.fallback.bind(this);
  }

  fallback() {
    if(this.props.fallbackSrc) {
      this.setState({ failed: true });
    }
  }

  render() {
    if (this.state.failed) {
      return <img src={this.props.fallbackSrc} className={this.props.className} alt='placeholder' />;
    } else {
      return <img src={this.props.src} onError={this.fallback} className={this.props.className} alt={this.props.alt} />;
    }
  }
}

FoodImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  fallbackSrc: PropTypes.string,
  className: PropTypes.string,
};

export default FoodImage;



// WEBPACK FOOTER //
// ./src/components/presentation/FoodImage.js